import Cookies from "js-cookie";

export const setAuthToken = (token: string) => {
    return Cookies.set("authToken", JSON.stringify(token));
};

export const getAuthToken = () => {
    const authToken = Cookies.get("authToken");
    if (authToken) {
        return JSON.parse(authToken);
    }
};
